function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M23.5,6H.5A.5.5,0,0,1,0,5.5V.5A.5.5,0,0,1,.5,0h23a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,23.5,6ZM1,5H23V1H1Zm22.5,9H.5a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,.5,8h23a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,23.5,14ZM1,13H23V9H1Zm22.5,9H.5a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,.5,16h23a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,23.5,22ZM1,21H23V17H1Z"
})));

var SvgListView = function SvgListView(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgListView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-view.6a89eee0.svg";
export { ForwardRef as ReactComponent };